// MobileFooter.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const MobileFooter = () => {
  const [messageCount, setMessageCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check login status
  useEffect(() => {
    const checkLogin = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);
    };
    checkLogin();
  }, []);

  // Fetch unread message count
  const fetchMessageCount = async () => {
    if (!isLoggedIn) {
      setMessageCount(0);
      return;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_MAIN_SITE_URL}/message/unread-count`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setMessageCount(response.data.count || 0);
    } catch (error) {
      console.error("Error fetching unread message count:", error);
      setMessageCount(0);
    }
  };

  // Poll every 30 seconds if logged in
  useEffect(() => {
    if (isLoggedIn) {
      fetchMessageCount(); // Initial fetch
      const intervalId = setInterval(fetchMessageCount, 30000);
      return () => clearInterval(intervalId); // Cleanup on unmount
    }
  }, [isLoggedIn]);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling for better UX
    });
  };

  return (
    <div className="mobile-footer">
      <div className="mobile-footer-icons">
        <Link to="/" className="mobile-footer-icon" onClick={scrollToTop}>
          <i className="icofont-home"></i>
          <span>Home</span>
        </Link>

        <Link to="/members" className="mobile-footer-icon" onClick={scrollToTop}>
          <i className="icofont-users"></i>
          <span>Friends</span>
        </Link>

          <Link to="/stories" className="mobile-footer-icon" onClick={scrollToTop}>
          <i className="icofont-video-alt"></i>
          <span>Stories</span>
        </Link>


        <Link to="/post" className="mobile-footer-icon" onClick={scrollToTop}>
          <i className="icofont-plus"></i>
          <span>Post</span>
        </Link>

            <Link to="/gallery" className="mobile-footer-icon" onClick={scrollToTop}>
          <i className="icofont-image"></i>
          <span>Gallery</span>
        </Link>



        <Link to="/community" className="mobile-footer-icon" onClick={scrollToTop}>
          <i className="icofont-people"></i>
          <span>Groups</span>
        </Link>

        <Link to="/chat" className="mobile-footer-icon" onClick={scrollToTop}>
          <div className="icon-wrapper">
            <i className="icofont-ui-chat"></i>
            {isLoggedIn && messageCount > 0 && (
              <span className="message-badge">{messageCount}</span>
            )}
          </div>
          <span>Chat</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileFooter;